import { Stand } from "@/shared/models/Stand";
import { MesfModal } from "@dexteel/mesf-core";
import { Button, Chip, Grid2, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";
import { StandsOfMillAdjustmentSelector } from "./StandsOfMillAdjustmentSelector";

type Props = {
	label: string;
	onSelectionChanged: Function;
	onSaved?: Function;
	standsOfMillAdjustment: Stand[];
	millAdjustmentId: number | null;
	limitSelectableStands?: String[];
	error?: FieldError | null;
	disabled?: boolean;
	required?: boolean;
	description?: string;
};

export const StandField = ({
	label,
	onSelectionChanged,
	onSaved,
	standsOfMillAdjustment,
	millAdjustmentId,
	limitSelectableStands,
	error,
	disabled = false,
	required = false,
	description,
}: Props) => {
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [initialStands, setInitialStands] = useState<Stand[]>([]);

	useEffect(() => {
		// Only setInitialStands in the first rendered
		if (initialStands.length === 0) {
			setInitialStands(standsOfMillAdjustment);
		}
	}, [millAdjustmentId]);

	return (
		<>
			<TextField
				required={required}
				label={label}
				disabled={disabled}
				onClick={() => {
					if (disabled) return;
					setOpenModal(true);
				}}
				variant="outlined"
				fullWidth
				size="small"
				error={!!error}
				helperText={error?.message}
				InputProps={{
					startAdornment: standsOfMillAdjustment
						.sort((a, b) => a.StandName.localeCompare(b.StandName))
						.map((stand) => (
							<Chip
								label={stand.StandName}
								size="small"
								color={`${
									stand.StandName?.includes("F") ? "primary" : "secondary"
								}`}
								variant="outlined"
								style={{ margin: "2px" }}
							/>
						)),
				}}
			/>
			<MesfModal
				title="CHOOSE STANDS"
				open={openModal}
				handleClose={() => setOpenModal(false)}
			>
				<MesfModal.Content dividers>
					<StandsOfMillAdjustmentSelector
						standsOfMillAdjustment={standsOfMillAdjustment}
						onSelectionChanged={onSelectionChanged}
						limitSelectableStands={limitSelectableStands}
					/>
					{description && (
						<Typography
							variant="h6"
							style={{ fontSize: "0.8rem" }}
							color="textSecondary"
						>
							{description}
						</Typography>
					)}
				</MesfModal.Content>
				<MesfModal.Actions>
					<Grid2 container spacing={2} justifyContent="flex-end">
						<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => {
									onSelectionChanged(initialStands);
									setOpenModal(false);
									setInitialStands([]);
								}}
							>
								Cancel
							</Button>
						</Grid2>
						<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="primary"
								onClick={() => {
									onSaved ? onSaved() : null;
									setOpenModal(false);
									setInitialStands([]);
								}}
							>
								Save
							</Button>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
